// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__xFlsu","slide":"Carousel_slide__lS8fv"};